export default {
  beforeDestroy() {
    this.$el.remove();
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
};
